export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[580px] md:min-h-[640px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 精选内容</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              探花系列 · 精品资源聚合平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-5">
              汇聚探花大神合集 · 发现探花一区精选
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              探花系列平台专注于精选内容聚合与资源分享，覆盖探花大神作品合集、探花91精品专区、探花一区热门资源等多元内容板块。
              每日持续更新优质内容，为探花迷打造一站式内容发现体验，让每一次浏览都充满惊喜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">2000+</div>
                <div className="text-xs text-foreground-500 mt-1">精选资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">持续上新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">安全稳定</div>
                <div className="text-xs text-foreground-500 mt-1">无忧浏览</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line"></i>
                探索精选内容
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-7 py-3 border border-background-300 hover:border-primary-400 text-foreground-700 hover:text-primary-600 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-hashtag"></i>
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-200/30 rounded-3xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3">
                <div className="space-y-3">
                  <div className="aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Curated%20digital%20content%20collection%20display%20with%20warm%20amber%20lighting%2C%20elegant%20grid%20layout%2C%20editorial%20photography%20style%2C%20clean%20minimal%20background%2C%20soft%20shadows%2C%20professional%20content%20curation%20aesthetic&width=600&height=450&seq=hero-card-01&orientation=landscape"
                      alt="探花系列精选内容合集"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="aspect-square rounded-xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Elegant%20resource%20library%20display%20with%20organized%20collections%2C%20warm%20golden%20accents%2C%20sophisticated%20layout%2C%20soft%20natural%20lighting%2C%20premium%20editorial%20aesthetic%2C%20clean%20background&width=500&height=500&seq=hero-card-02&orientation=squarish"
                      alt="探花大神作品合集"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="space-y-3 pt-8">
                  <div className="aspect-square rounded-xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Premium%20content%20showcase%20with%20highlighted%20featured%20items%2C%20warm%20coral%20and%20amber%20tones%2C%20luxurious%20editorial%20photography%2C%20soft%20lighting%2C%20refined%20aesthetic%2C%20clean%20minimal%20composition&width=500&height=500&seq=hero-card-03&orientation=squarish"
                      alt="探花一区热门精选"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Artistic%20content%20discovery%20platform%20interface%2C%20elegant%20card%20layout%2C%20warm%20lighting%2C%20sophisticated%20design%2C%20editorial%20photography%2C%20clean%20background%2C%20premium%20digital%20experience&width=600&height=450&seq=hero-card-04&orientation=landscape"
                      alt="探花探花精选推荐"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-background-50 rounded-full px-4 py-1.5 shadow-sm border border-background-200/70 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">实时更新中 · 新内容陆续上线</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}